import axios from "axios";
import { Settings } from "../models/Settings.model";
import { getEntity } from "../utils/entities/getEntity";
import { entitiesQueryParamName } from "../utils/entities/constants";

// FAVORITE LINES
async function getFavLines() {
  try {
    const res = await axios.get("/my-tib/favorites/lines");
    return res.data.favoriteLinesInfoList;
  } catch (err) { }
}

async function addFavLine(lineId: number) {
  const res = await axios.put(`my-tib/favorites/lines/${lineId}`);
  return res.data;
}

async function updateFavLine(lineId: number, active: boolean) {
  let config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const res = await axios.post(
      `my-tib/favorites/lines/${lineId}`,
      active,
      config
  );
  return res.data;
}

async function deleteFavLine(lineId: number) {
  const res = await axios.delete(`my-tib/favorites/lines/${lineId}`);
  return res.data;
}

// FAVORITE STOPS
async function getFavStops() {
  try {
    const res = await axios.get("/my-tib/favorites/stops");
    return res.data.favoriteStopsInfo;
  } catch (err) { }
}

async function addFavStop(stopId: number) {
  const res = await axios.put(`/my-tib/favorites/stops/${stopId}`);
  return res.data;
}

async function updateFavStop(stopId: number, active: boolean) {
  let config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.post(
        `/my-tib/favorites/stops/${stopId}`,
        active,
        config
    );
    return res.data;
  } catch (err) { }
}

async function deleteFavStop(stopId: number) {
  try {
    const res = await axios.delete(`/my-tib/favorites/stops/${stopId}`);
    return res.data;
  } catch (err) { }
}

// MY PROFILE
async function getMyProfile() {
  const entity = getEntity();
  const res = await axios.get(`/my-user?${entitiesQueryParamName}=${entity.id}`);
  return res.data;
}

async function getSettings() {
  const res = await axios.get("/my-tib/my-profile/settings");
  return res.data;
}

async function updateSettings(settings: Settings) {
  const res = await axios.put(`/my-tib/my-profile/settings`, settings);
  return res.data;
}

async function updateStudentProfile(data: object) {
  let config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const res = await axios.post(
      `my-tib/my-profile/students/`,
      data,
      config
  );

  return res.data;
}

/**
 * Obtiene el informe PDF del historial del usuario
 * @returns Blob con el contenido del PDF o undefined en caso de error
 */
async function getUserHistoryReport(): Promise<Blob | undefined> {
  try {
    const entity = getEntity();
    const res = await axios.get(
      `/my-tib/reports/user-history?${entitiesQueryParamName}=${entity.id}`,
      {
        responseType: 'blob'
      }
    );
    return res.data;
  } catch (err) {
    console.info("Error fetching user history report:", err);
    return undefined;
  }
}

export const MyTibApi = {
  getFavLines,
  addFavLine,
  updateFavLine,
  deleteFavLine,
  getFavStops,
  addFavStop,
  updateFavStop,
  deleteFavStop,
  getMyProfile,
  getSettings,
  updateSettings,
  updateStudentProfile,
  getUserHistoryReport
};
